<template>
    <v-card id="funding" elevation="4" class="mb-8">
        <v-toolbar color="green darken-4" dark flat dense>
            <v-toolbar-title>Your Part-Time Funding</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-scroll-to="'#top'" dark text>
                <v-icon left>fas fa-chevron-up</v-icon>
                Top
            </v-btn>
            <span v-scroll-to="'#kickers'" class="fa-stack fa-md icon-info">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-info fa-stack-1x"></i>
            </span>
        </v-toolbar>
        <v-card-text>
            <v-alert v-if="HasFTEnrolments" type="warning" outlined dense text>If you are also studying a full-time programme, you will not be eligible to use the fee waiver option to fund your part-time study</v-alert>
            <p>Most students studying part-time, including distance learning, will have to pay tuition fees. With this in mind, the College has dedicated staff that can guide you through the various options available to you and help you make the right decision.</p>
            <p>The short guide below may also help you decide which payment option would be most suitable to you.</p>
            <h4>The courses below are then the ones you have applied for that fall into this category of funding:</h4>
        </v-card-text>
        <v-card-text>
            <v-card v-for="enrolment in PTEnrolments" :key="enrolment.enrolmentID" class="mb-4" outlined>
                <v-card-title>
                    <span class="body-1">{{ enrolment.CourseCode }} - {{ enrolment.CourseName }}</span>
                </v-card-title>
            </v-card>
        </v-card-text>
        <v-card-actions>
            <v-btn href="https://dundeeandangus.ac.uk/advice-support/finance-funding/funding-for-part-time-courses/" target="_blank" color="info" dark small style="color:white !important">
                <v-icon left small>fas fa-info-circle</v-icon>
                Part-Time Funding Guidance
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'

    export default {
        props: ['enrolments'],
        mixins: [enrolmentsMixin],
    }
</script>
